import { IEventSystem } from "@dhx/ts-common/events";
import { IDataCollection } from "@dhx/ts-data";

export interface IData {
	[key: string]: any;
}

export interface IPropertyConfig {
	id?: string;
	type?: string;
	title?: string;
}

// tslint:disable-next-line:interface-name
export interface CustomEvent extends Event {
	target: HTMLElement;
	srcElement: HTMLElement;
}

export interface IProperty {
	events: IEventSystem<PropertyEvents>;
	data: IDataCollection;

	clear();
	getValues();
	setValues(data: IData);
	paint();
	isItemSelected(id: string): boolean;
	isItemsSelected(): boolean;
	selectItem(id: string);
}

export enum PropertyEvents {
	change = "change",
	beforeFileUpload = "onBeforeFileUpload",
	afterFileUpload = "afterFileUpload",
}
